/* eslint-disable no-nested-ternary */
import React, { FC, memo, useMemo } from 'react'
import styled from 'styled-components'

import IconStarFilled from '@ucheba/ui/icons/icon__star-filled.svg'
import { ListItem } from '@ucheba/ui/components/List/desktop'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Avatar } from '@ucheba/ui/components/Avatar/desktop'

import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { Details, Divider, Rating, UserNameBlock } from '../base/styled'

import { IItemProps } from '../types'

import Controls from './Controls'

const GridColStyled = styled(GridCol)`
  padding-top: 0;
  padding-bottom: 0;
`

const GridStyled = styled(Grid)`
  margin-top: 0;
  margin-bottom: 0;
`

const Item: FC<IItemProps> = ({
  isDivider = true,
  isResponse,
  id,
  date,
  text,
  program,
  owner,
  type,
  rate,
  faculty,
  voteStats,
  responseFor,
  onAnswerClick,
  itemsLength,
  rootId,
  rootType,
  limit,
  offset,
}) => {
  const { fullName, avatar, isInstitutionRepresentative } = owner

  const responseNameSplit = responseFor?.fullName.split(' ')

  // Или имя адресата или программа или факультет или "О вузе"
  const details = useMemo(
    () =>
      responseFor?.fullName
        ? `Ответ ${
            responseNameSplit.length > 1 ? responseNameSplit[1] : responseNameSplit
          }`
        : program
          ? `О программе ${program?.name}`
          : faculty
            ? `О факультете ${faculty?.name}`
            : 'Об учебном заведении',

    [faculty, program, responseFor?.fullName, responseNameSplit]
  )

  return (
    <ListItem spacingH='null' id={String(id)}>
      {isDivider && (
        <>
          <Divider />

          <Spacing spacing='xlarge' />
        </>
      )}

      <GridStyled nowrap spacing='small'>
        <GridColStyled width='auto'>
          <Avatar imgUrl={avatar?.thumb?.fallbackUrl} size='large' />
        </GridColStyled>

        <GridColStyled width='100%' shrink='initial'>
          <UserNameBlock>
            <Text fontWeight='bold' fontSize='h3'>
              {fullName}
            </Text>

            {isInstitutionRepresentative && isResponse && (
              <Chips color='blue'>Официальный представитель</Chips>
            )}

            {!!rate && (
              <Rating>
                <IconStarFilled />

                <Text color='orange' fontWeight='bold' fontSize='h3'>
                  {rate}
                </Text>
              </Rating>
            )}
          </UserNameBlock>

          <Spacing spacing='usmall' />

          <Details>
            <div>{details}</div>
            <div>{dayjs(date).format('DD MMMM YYYY')}</div>
          </Details>

          <Spacing spacing='xsmall' />

          <Text>{text}</Text>

          <Spacing spacing='xsmall' />

          <Controls
            voteStats={voteStats}
            type={type}
            id={id}
            onAnswerClick={onAnswerClick}
            listLength={itemsLength}
            rootId={rootId}
            rootType={rootType}
            limit={limit}
            offset={offset}
          />
        </GridColStyled>
      </GridStyled>
    </ListItem>
  )
}

export default memo(Item)
